import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { formatDate, DatePipe } from '@angular/common';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs/operators';
import usStateLocations from '../../../../assets/us-state-locations.json';
import employmentTypes from '../../../../assets/employment-types.json';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EmployeeInformationService } from 'src/app/data-analysis-summary/employee-information/employee-information.service';
import { SessionService } from '../../session-service/session.service';
import { NegativeValidator } from '../../../core/validators/negative-validator';
import { toLocalDatePipe } from '../../../core/pipes/local-date-format.pipes';
import { ToastrService } from '@kpmg-tax/ui';
import { Messages } from '../../constants/messages';
import { BaseResponse } from '../../models/base-response.model';
import { TaxPeriod } from '../../models/engagement/TaxPeriod';
import { copyObject } from 'src/app/shared/lib/custom-tools';
import { encodeText } from 'src/app/shared/lib/custom-tools';
import { State } from '../add-an-employee-form/locations.model';

@Component({
  selector: 'ei-edit-single-employee',
  templateUrl: './ei-edit-single-employee.component.html',
  styleUrls: ['../add-an-employee-form/add-an-employee-form.component.scss'],
  providers: [toLocalDatePipe],
})

export class EiEditSingleEmployeeComponent implements OnInit, AfterViewChecked {
  constructor(
    public rightSideDrawerService: RightSideDrawerService,
    private formBuilder: FormBuilder,
    private employeeInformationService: EmployeeInformationService,
    public sessionService: SessionService,
    private tolocaldatepipe: toLocalDatePipe,
    public datePipe: DatePipe,
    public toastrService: ToastrService,
  ) {
    this.clientId = this.sessionService.getSession('clientId');
    this.employeeInformationService.GetClientUsers(this.clientId).subscribe(
      (data: any) => {
        this.SMEList = data.result;
      });
  }

  targetForm: FormGroup; // name of formGroup in template
  targetFormSubmitted: boolean = false;
  employmentDatesError: boolean = false; // trigger for CSS
  employeeDatesErrorMessage: string = ''; // MEssage for Dates Error
  employeeNumberError: boolean = false; // trigger for CSS
  currentDate: Date = new Date();
  hireDate: Date = null;
  termDate: Date = null;
  maxDate: Date = new Date(2999, 25, 12);
  hireDateRequired: boolean = false;
  @ViewChild('dpStart', { static: true }) dpStart;
  @ViewChild('dpEnd', { static: true }) dpEnd;
  isDisabled: boolean = true;
  editRowData: any;
  addDisabledLocation: boolean = false;
  addDisabledEmployment: boolean = false;
  addDisabledTaxPeriod: boolean = false;
  noResultsLocation: boolean = false;
  noResultsEmployment: boolean = false;
  noResultsTaxPeriod: boolean = false;
  displayNoResultsLocation: boolean = false;
  displayNoResultsEmployment: boolean = false;
  displayNoResultsTaxPeriod: boolean = false;
  clientId: any;
  SMEList: any[];
  statesunsorted:State[]=[];
  states: string[]=[];
  locationMap = new Map<string, string>();
  private unsubscribe$ = new Subject<void>();

  public employment = employmentTypes.map(function (item) {
    return item.employment;
  }).sort((a, b) => a.localeCompare(b));

  public taxPeriods: TaxPeriod[] = this.rightSideDrawerService.taxPeriods;
  public taxPeriodNames: string[] = this.taxPeriods.map(x => x.taxPeriodName);

  get f() {
    return this.targetForm?.controls;
  }

  ngOnInit() {
    this.employeeInformationService.getLocations().pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(
      (response:any) => {
        if (response && response.result) {
          this.statesunsorted = response.result as State[];      

          this.statesunsorted.forEach(item=>{
            this.locationMap.set(item.code.length === 2 ? item.code : item.name, item.code);
            
           })
                
        
          const twoCharCodes = this.statesunsorted
          .filter(item => item.code.length === 2)
          .map(item => item.code.trim());
  
        const otherCodes = this.statesunsorted
          .filter(item => item.code.length !== 2)
          .map(item => item.name.trim());
  
        
        twoCharCodes.sort((a, b) => a.localeCompare(b));
        otherCodes.sort((a, b) => a.localeCompare(b));    
       
        this.states = [...twoCharCodes, ...otherCodes];     
        this.resetRightSideDrawerData();
        this.editRowData = this.rightSideDrawerService.singleRowEditData;
        }
      }
    );
        
   
        }
      
    
        

  ngAfterViewChecked() {
    // Refresh form inputs if drawer is opened or loaded.
    if (this.rightSideDrawerService.triggerRightSideDrawerClick) {
      this.rightSideDrawerService.triggerRightSideDrawerClick = false; // Set trigger to false so that this action is only performed once. Without this, the form would keep resetting on every change on any input.
      this.resetRightSideDrawerData();
    }
  }

  setStartDate(date: Date) {
    this.hireDate = date;
    if (this.hireDate > this.currentDate) {
      this.employmentDatesError = true;
      this.employeeDatesErrorMessage =
        Messages.AddEmployeeForm.HIRE_DATE_VALIDATION;
    } else {
      this.employmentDatesError = false;
      this.checkValidDates();
    }
    this.targetForm.controls['hireDate'].setValue(date);
    this.onEditEmpData();
  }

  setEndDate(date: Date) {
    this.termDate = date;
    
    if (this.termDate) {
      if (this.termDate < this.hireDate) {
        this.employmentDatesError = true;
        this.employeeDatesErrorMessage =
          Messages.AddEmployeeForm.TERMINATION_DATE_VALIDATION;
      } else {
        this.employmentDatesError = false;
        this.checkValidDates();
      }
    } else if (
      this.employeeDatesErrorMessage ===
      Messages.AddEmployeeForm.TERMINATION_DATE_VALIDATION
    ) {
      this.employmentDatesError = false;
    }
    this.targetForm.controls['endDate'].setValue(date);
    this.onEditEmpData();
  }

  // Validate start date isn't greater than end date if end date is specified
  checkValidDates() {
    if (this.termDate > this.currentDate) {
      /* if Terrmination Date is after Current Date */ this.employmentDatesError = true;
      this.employeeDatesErrorMessage =
        Messages.AddEmployeeForm.TERMINATION_DATE_VALIDATION2;
    } else if (this.termDate < this.hireDate && this.termDate) {
      this.employmentDatesError = true;
      this.employeeDatesErrorMessage =
        Messages.AddEmployeeForm.TERMINATION_DATE_VALIDATION;
    } else {
      this.hireDateRequired = false;
      this.employmentDatesError = false;
    }
  }

  checkHours = () => {
    // If hours are present in form, estimate number to two decimal points
    let totalHours = this.targetForm.get('totalHours').value;

    if (totalHours) {
      totalHours = Math.round(totalHours * 100) / 100;
      this.targetForm.controls.totalHours.setValue(totalHours);
    }
  }

  checkWage = () => {
    let wage = this.targetForm.get('wage').value;

    // If wage is  present in form, estimate number to two decimal points.
    if (wage) {
      wage = Math.round(wage * 100) / 100;
      this.targetForm.controls.wage.setValue(wage);
    }
  }

  // Check if the Employee Number is listed within the engagement.
  checkEmployeeNumber = () => {
    let employeeNo = this.targetForm.get('employeeNumber').value;

    // If employeeNumber field is null or undefined
    if (employeeNo === null || employeeNo === undefined) {
      this.employeeNumberError = true;
    } else if (
      this.employeeInformationService.employeeNumberListFromTable.includes(
        employeeNo,
      )
    ) {
      this.employeeNumberError = true;
      // If employeeNumber is not in the engagement, error is false
    } else {
      this.employeeNumberError = false;
    }
  }

  // Delete empty properties to clean form data to send to back-end API
  // Blank values sent to the back-end API gives errors.
  cleanTargetFormToPost = () => {
    // Make a copy of what the form holds
    this.targetForm.value.engagementId = this.sessionService.getSession(
      'engagementId',
    );

    let patchOutput = copyObject(this.targetForm.value);

    // Remove properties that are null, empty, or undefined
    if (patchOutput.endDate === 'NaN-NaN-NaN' || patchOutput.endDate == '' || patchOutput.endDate == undefined) {
      patchOutput.endDate = null;
    }
    else {
      patchOutput.endDate = formatDate(patchOutput.endDate, 'MM/dd/yyyy', 'en-US')
    }

    if (patchOutput.hireDate === 'NaN-NaN-NaN' || patchOutput.hireDate == '' || patchOutput.hireDate == undefined) {
      patchOutput.hireDate = null;
    }
    else {
      patchOutput.hireDate = formatDate(patchOutput.hireDate, 'MM/dd/yyyy', 'en-US')
    }


    if (this.taxPeriodNames?.length == 1) {
      patchOutput.taxPeriod = this.taxPeriodNames[0];
    }

    patchOutput.employeeNumber = this.rightSideDrawerService.singleRowEditData.employeeNumber;


    return (patchOutput = this.sessionService.removeNullEmptyValues(
      patchOutput,
    ));
  }

  // This function runs when "Edit Employee" button is clicked
  putRightSideDrawerData = () => {
    // Reset Employment Date Error trigger
    this.employmentDatesError = false;

    this.isDisabled = true;
    const employeeData = this.cleanTargetFormToPost();
    employeeData.employeeNumber = encodeText(employeeData.employeeNumber);
    employeeData.name = encodeText(employeeData.name);
    employeeData.title = encodeText(employeeData.title);
    employeeData.type = encodeText(employeeData.type);
    employeeData.costCenter = encodeText(employeeData.costCenter);
    employeeData.costCenterDesc = encodeText(employeeData.costCenterDesc);
    employeeData.company = encodeText(employeeData.company);
    employeeData.taxPeriodId = this.taxPeriods
      .find(x => x.taxPeriodName.trim().toLowerCase() == employeeData.taxPeriod.trim().toLowerCase())?.taxPeriodId;
    employeeData.taxPeriod = '';
    employeeData.location=this.locationMap.get(this.targetForm.get('location').value)
    this.employeeInformationService
      .updateEmpData(employeeData)
      .subscribe(
        (data: BaseResponse) => {
          if (data && data.success) {
            this.toastrService.setSuccessMessage(
              Messages.UPDATE_SUCCESS_MESSAGE,
            );
            // Refresh data table on page
            this.employeeInformationService.refreshTable();
            this.rightSideDrawerService.closeRightSideDrawer();
          } else {
            this.toastrService.setErrorMessage(data.errorMessage);
          }
        },
        // Show in console if there is an error given from the back end.
        error => {
          this.isDisabled = false;
          console.log(
            'add-an-employee-form.component.ts -- Error returned from back-end. Attempted to send form: ',
            this.cleanTargetFormToPost(),
          );
        },
      );

    // Refresh data table on page
    //this.employeeInformationService.refreshTable();

    // Change variable to note a form submission attempt was made.
    this.targetFormSubmitted = true;
  }

  openDatePickerEnd() {
    this.dpEnd.toggle();
  }

  openDatePickerStart() {
    this.dpStart.toggle();
  }

  onfocStartDate() {
    setTimeout(() => {
      this.dpStart?.show();
    }, 100);
  }

  onfocEndDate() {
    setTimeout(() => {
      this.dpEnd?.show();
      this.dpStart.hide();
    }, 100);
  }

  clearStartDate() {
    this.targetForm.controls['hireDate'].setValue(null);
  }
  clearEndDate() {
    this.targetForm.controls['endDate'].setValue(null);
    this.employmentDatesError = false;
  }

  dropdownInputChanged() {
    setTimeout(() => this.onEditEmpData(), 100);
  }

  checkTaxPeriod = () => {
    let taxPeriodValue = this.targetForm.get('taxPeriod').value;
    if (taxPeriodValue) {
      let taxPeriod = (String(taxPeriodValue)).toLocaleUpperCase();
      if (taxPeriod === null || taxPeriod === undefined || taxPeriod == '') {
        this.addDisabledTaxPeriod = true;
      } else if (this.taxPeriodNames.some(x => x.toLocaleUpperCase() == taxPeriod)) {
        this.addDisabledTaxPeriod = false;
      }
    }
    else {
      this.addDisabledTaxPeriod = true;
    }
  }

  onEditEmpData() {
    this.checkTaxPeriod();
    let activity: any = {
      name: this.targetForm.get('name').value,
      type: this.targetForm.get('type').value,
      title: this.targetForm.get('title').value,
      costCenter: this.targetForm.get('costCenter').value,
      costCenterDesc: this.targetForm.get('costCenterDesc').value,
      location: this.locationMap.get(this.targetForm.get('location').value),
      hireDate:
        this.targetForm.get('hireDate').value === '' ||  !this.targetForm.get('hireDate').value
          ? null
          : formatDate(this.targetForm.get('hireDate').value, 'MM/dd/yyyy', 'en-US'),
      endDate:
        this.targetForm.get('endDate').value === '' || !this.targetForm.get('endDate').value
          ? null
          : formatDate(this.targetForm.get('endDate').value, 'MM/dd/yyyy', 'en-US'),
      totalHours: this.targetForm.get('totalHours').value,
      wage: this.targetForm.get('wage').value,
      sme: this.targetForm.get('sme').value,
      company: this.targetForm.get('company').value,
      priorYearQualifiedPercentage: this.targetForm.get('priorYearQualifiedPercentage').value,
      taxPeriodName: this.targetForm.get('taxPeriod').value
    };

    if (
      this.targetForm.get('location').value === '' ||
      this.targetForm.get('location').value === null ||
      (this.states.findIndex(
        item =>
          item.toLowerCase() ===
        this.targetForm.get('location').value.toLowerCase(),
      ) ===
        -1) ===
      false
    ) {
      this.addDisabledLocation = false;
      this.displayNoResultsLocation = false;
    }
    if (
      this.targetForm.get('type').value === '' ||
      this.targetForm.get('type').value === null ||
      (this.employment.findIndex(
        item =>
          item.toLowerCase() ===
          this.targetForm.get('type').value.toLowerCase(),
      ) ===
        -1) ===
      false
    ) {
      this.addDisabledEmployment = false;
      this.displayNoResultsEmployment = false;
    }

    let hireDate = this.editRowData.hireDate ? formatDate(this.editRowData.hireDate, 'MM/dd/yyyy', 'en-US') : null;
    let endDate = this.editRowData.endDate ? formatDate(this.editRowData.endDate, 'MM/dd/yyyy', 'en-US') : null;

    if (
      activity.name !== this.editRowData.name ||
      activity.type !== this.editRowData.type ||
      activity.title !== this.editRowData.title ||
      activity.costCenter !== this.editRowData.costCenter ||
      activity.costCenterDesc !== this.editRowData.costCenterDesc ||
      activity.location !== this.editRowData.location ||
      activity.hireDate !== hireDate ||
      activity.endDate !== endDate ||
      activity.totalHours !== this.editRowData.totalHours ||
      activity.wage !== this.editRowData.wage ||
      activity.sme !== this.editRowData.sme ||
      activity.company !== this.editRowData.company ||
      activity.priorYearQualifiedPercentage !== this.editRowData.priorYearQualifiedPercentage ||
      activity.taxPeriodName != this.editRowData.taxPeriodName
    ) {
      this.isDisabled = false;
      this.rightSideDrawerService.setMandatoryField(true, 'Edit Employee');
    } else {
      this.isDisabled = true;
      this.rightSideDrawerService.setMandatoryField(false, '');
    }
  }
  public buildFrom(employee) {
    this.rightSideDrawerService.singleRowEditData = employee;
  }

  // reset form content. This reloads original content from row selected.
  public resetRightSideDrawerData = () => {
    let hireDate = this.rightSideDrawerService.singleRowEditData.hireDate;
    let endDate = this.rightSideDrawerService.singleRowEditData.endDate;

    hireDate === null
      ? (hireDate = '')
      : (hireDate = formatDate(hireDate, 'MM/dd/yyyy', 'en-US'));
    endDate === null
      ? (endDate = '')
      : (endDate = formatDate(endDate, 'MM/dd/yyyy', 'en-US'));

      const getKeyByValue = (map: Map<string, string>, searchValue: string): string | undefined => {
        for (let [key, value] of map.entries()) {
          if (value === searchValue) {
            return key;
          }
        }
        return undefined;
      };

      const locationValue = this.rightSideDrawerService.singleRowEditData.location;
    const locationKey = getKeyByValue(this.locationMap, locationValue);

    this.targetForm = this.formBuilder.group({
      engagementId: [this.sessionService.engagementIdFocus],
      employeeId: [this.rightSideDrawerService.singleRowEditData.employeeId],
      employeeNumber: [
        { value: this.rightSideDrawerService.singleRowEditData.employeeNumber, disabled: true },
        [Validators.required, Validators.maxLength(100)],
      ],
      name: [
        this.rightSideDrawerService.singleRowEditData.name,
        [Validators.required, Validators.maxLength(100)],
      ],
      title: [
        this.rightSideDrawerService.singleRowEditData.title,
        Validators.maxLength(200),
      ],
      type: [
        this.rightSideDrawerService.singleRowEditData.type,
        Validators.maxLength(100),
      ],
      costCenter: [
        this.rightSideDrawerService.singleRowEditData.costCenter,
        Validators.maxLength(100),
      ],
      costCenterDesc: [
        this.rightSideDrawerService.singleRowEditData.costCenterDesc,
        Validators.maxLength(100),
      ],
      location: [locationKey],
      hireDate: hireDate,
      endDate: endDate,
      totalHours: [
        this.rightSideDrawerService.singleRowEditData.totalHours,
        [
          Validators.pattern(/^[0-9]\d*$/),
          NegativeValidator.cannotBeNegativeNumber,
        ],
      ],
      wage: [
        this.rightSideDrawerService.singleRowEditData.wage,
        NegativeValidator.cannotBeNegativeNumber,
      ],
      sme: [
        this.rightSideDrawerService.singleRowEditData.sme,
        Validators.maxLength(500),
      ],
      company: [
        this.rightSideDrawerService.singleRowEditData.company,
        Validators.maxLength(100),
      ],
      priorYearQualifiedPercentage: [
        this.rightSideDrawerService.singleRowEditData.priorYearQualifiedPercentage,
        NegativeValidator.cannotBeNegativeNumber,
      ],
      taxPeriod: [{
        value: this.rightSideDrawerService.singleRowEditData.taxPeriodName,
        disabled: this.taxPeriodNames?.length == 1
      }],
    });

    // Reset CSS triggers
    this.employeeNumberError = false;
    this.employmentDatesError = false;
    this.targetFormSubmitted = false;
  }

  // format date for form.
  dateFormatter = date => {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  trimSpecialChar(ctrl: any) {
    if (this.targetForm.get(ctrl).value) {
      if (this.targetForm.get(ctrl) === this.targetForm.get('name')) {
        this.targetForm.controls[ctrl].setValue(
          this.targetForm.get(ctrl).value.replace(/['\x22\x60]+/g, ''),
        );
      } else {
        this.targetForm.controls[ctrl].setValue(
          this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._/@, ]/g, ''),
        );
      }
    }
  }

  checkDates() {
    if ((this.targetForm.controls.endDate.value === null || this.targetForm.controls.endDate.value === '') && this.employmentDatesError) {
      this.employmentDatesError = false;
    }
  }


  // Search filter function for TypeAhead text input. Used for Location input.
  searchLocation = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(150),
      distinctUntilChanged(),
      tap(term => {
        // Remove "no results" message in case it was displayed from the previous search
        this.noResultsLocation = false;
        this.displayNoResultsLocation = false;
      }),
      switchMap((term: string) => {
        // Process the search term entered
        return this.searchLocations(term).pipe(
          switchMap(data => {
            this.noResultsLocation = data.length === 0;
            if (this.noResultsLocation) {
              this.addDisabledLocation = true;
              this.displayNoResultsLocation = true;
            } else {
              /* Explanation: The dropdown menu looks to see if the term matches any state codes; however, the current scenario means that, in the case where the user types
            in something that could be part of a state code (Example: the user types in 'A' and nothing else), it is accepted as a state code.

            In the case where the user's input is not an exact match to the state code, we disable the "Save Employee" button. However, we create the "displayNoResultsLocation"
            variable to make sure that the "No Location Found" error does not pop up in the middle of what the user was typing.
            */
              if (
                (this.states.findIndex(
                  item => item.toLowerCase() === term.toLowerCase(),
                ) !==
                  -1) ===
                false &&
                term !== ''
              ) {
                this.addDisabledLocation = true;
              } else {
                this.addDisabledLocation = false;
              }
            }
            return of(data);
          }),
          catchError(() => {
            this.noResultsLocation = true;
            return of([]);
          }),
        );
      }),
    )

  
    public searchLocations(term: string): Observable<any> {
      return of(this.states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1));
    }

  searchEmploymentType = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(150),
      distinctUntilChanged(),
      tap(term => {
        // Remove "no results" message in case it was displayed from the previous search
        this.noResultsEmployment = false;
        this.displayNoResultsEmployment = false;
      }),
      switchMap((term: string) => {
        // Process the search term entered
        return this.searchEmploymentTypes(term).pipe(
          switchMap(data => {
            this.noResultsEmployment = data.length === 0;
            if (this.noResultsEmployment) {
              this.addDisabledEmployment = true;
              this.displayNoResultsEmployment = true;
            } else {
              /* Explanation: The dropdown menu looks to see if the term matches any employment types; however, the current scenario means that, in the case where the user types
              in something that could be part of a employment type (Example: the user types in 'A' and nothing else), it is accepted as an employment type.

              In the case where the user's input is not an exact match to the employment type, we disable the "Save Employee" button. However, we create the 
              "displayNoResultsEmployment" variable to make sure that the "No Employment Type Found" error does not pop up in the middle of what the user was typing.
              */
              if (
                (this.employment.findIndex(
                  item => item.toLowerCase() === term.toLowerCase(),
                ) !==
                  -1) ===
                false &&
                term !== ''
              ) {
                this.addDisabledEmployment = true;
              } else {
                this.addDisabledEmployment = false;
              }
            }
            return of(this.employment);
          }),
          catchError(() => {
            this.noResultsEmployment = true;
            return of([]);
          }),
        );
      }),
    )

  public searchEmploymentTypes(term: string): Observable<any> {
    return of(
      this.employment
        .filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)
    );
  }

  searchTaxPeriod = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(150),
      distinctUntilChanged(),
      tap(term => {
        // Remove "no results" message in case it was displayed from the previous search
        this.noResultsTaxPeriod = false;
        this.displayNoResultsTaxPeriod = false;
      }),
      switchMap((term: string) => {
        // Process the search term entered
        return this.searchTaxPeriodNames(term).pipe(
          switchMap((data: string) => {
            this.noResultsTaxPeriod = data.length === 0;
            if (this.noResultsTaxPeriod) {
              this.addDisabledTaxPeriod = true;
              this.displayNoResultsTaxPeriod = true;
            } else {
              if (
                (this.taxPeriodNames.findIndex(
                  item => item.toLowerCase() === term.toLowerCase(),
                ) !==
                  -1) ===
                false &&
                term !== ''
              ) {
                this.addDisabledTaxPeriod = true;
              } else if (term == null || term == undefined || term == '') {
                this.addDisabledTaxPeriod = true;
              } else {
                this.addDisabledTaxPeriod = false;
              }
            }
            return of(this.taxPeriodNames);
          }),
          catchError(() => {
            this.noResultsTaxPeriod = true;
            return of([]);
          }),
        );
      }),
    )

  public searchTaxPeriodNames(term: string): Observable<any> {
    return of(this.taxPeriodNames
      .filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1));
  }


  searchSMEStream = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(150),
      distinctUntilChanged(),
      switchMap((term: string) => {
        return this.searchSMEs(term);
      }),
    );

  public searchSMEs(term: string): Observable<any> {
    let temList = this.SMEList;
    if (temList) {
      return of(
        temList
          .filter(item => item.displayName.toLowerCase().includes(term.toLowerCase()))
          .map(x => {
            return x.displayName;
          }),
      );
    } else {
      return of([]);
    }
    
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
